const {
  VITE_NODE_ENV: env,
  BASE_URL: baseUrl,
  VITE_API_BASE_URL: apiBaseUrl,
  VITE_API_MS_BASE_URL: apiMSBaseUrl,
  SENTRY_AUTH_TOKEN: SENTRY_AUTH_TOKEN,
  VITE_FLUTTERWAVE_ENV: flutterWaveEnv,
  VITE_GA_MEASUREMENT_ID: gaMeasurementId,
  VITE_CUBEJS_DB_HOST: CUBEJS_DB_HOST,
  VITE_RECAPTCHA_SITE_KEY_V3: recaptchaSiteKeyV3,
  VITE_RECAPTCHA_SITE_KEY_V2: recaptchaSiteKeyV2,
  VITE_GOOGLE_API_KEY: googleApiKey,
} = import.meta.env;

export default {
  env,
  baseUrl,
  apiBaseUrl,
  apiMSBaseUrl,
  flutterWaveEnv,
  isDev: env === 'development',
  gaMeasurementId,
  CUBEJS_DB_HOST,
  SENTRY_AUTH_TOKEN,
  recaptchaSiteKeyV3,
  recaptchaSiteKeyV2,
  googleApiKey,
};
